// extracted by mini-css-extract-plugin
module.exports = {"progressBarContainer":"jgp-2rYHX","foregroundBar":"jgp-AerOD","instagramShareProgressBarContainer":"jgp-11dXe","totalSpan":"jgp-1vnBp","raisedByText":"jgp-3a-oC"};